import React, { useState, useEffect, ReactNode } from "react";

import companylogo from "../../assets/app_logo.svg";
import background from "../../assets/background.svg";
import desktopBg from "../../assets/desktop-bg.svg";

import { WELCOME_TEXT1, WELCOME_TEXT2, CES_TEXT, LOGIN } from "../../constants/constants";

import Loader from "../loader/login-loader";

import styles from "./styles.module.css";

interface LandingProps {
    mid?: {
        accessToken?: () => string | null;
        isAuthed: () => boolean;
        login: () => void;
    };
    children?: ReactNode;
}

const LandingPage: React.FC<LandingProps> = ({ mid, children }) => {
    const [loginState, updateState] = useState({
        isAuthed: false,
        isLoading: true,
        initialLoading: true,
        loaderStart: false,
    });

    const { loaderStart } = loginState;
    const accessToken = window.sessionStorage.getItem("_mid-access-token") || "";

    const checkIsAuth = (checkAuth: boolean) => {
        updateState((prevState) => ({
            ...prevState,
            isAuthed: checkAuth,
            isLoading: false,
            initialLoading: false,
            loaderStart: checkAuth,
        }));
    };

    useEffect(() => {
        const checkAuthentication = async () => {
            if (accessToken) {
                checkIsAuth(true);
            } else if (window.location.pathname.includes("/text-analytics")) {
                try {
                    const loginStatus = mid?.isAuthed();
                    checkIsAuth(loginStatus ?? false);
                } catch (error) {
                    console.error("Error checking auth status:", error);
                    checkIsAuth(false);
                }
            } else {
                checkIsAuth(false);
            }
        };

        checkAuthentication();
    }, [mid]);

    const submitHandler = () => {
        updateState((prevState) => ({
            ...prevState,
            isLoading: true,
            loaderStart: true,
        }));

        setTimeout(() => {
            updateState((prevState) => ({
                ...prevState,
                isAuthed: true,
                loaderStart: false,
            }));
        }, 2000);
    };

    if (loginState.isAuthed) {
        return <>{children}</>;
    }

    return (
        <>
            {loaderStart && <Loader blur={true} />}
            <div className={styles.logincomponent}>
                <div
                    className={styles.backgroundWrapper}
                    style={{
                        background: `url(${background}) no-repeat center center`,
                        backgroundSize: "cover",
                    }}
                >
                    <div className={styles.loginTop}>
                        <img src={companylogo} alt="company-logo" className={styles.companyLogo} />
                    </div>
                    <div className={styles.container}>
                        <h1 className={styles.welcomeText1}>
                            {WELCOME_TEXT1} <br />
                            <span className={styles.welcomeText2}>{WELCOME_TEXT2}</span>
                        </h1>
                        <button className={styles.loginButton} onClick={submitHandler}>
                            {LOGIN}
                        </button>
                    </div>

                    <div className={styles.cesText}>{CES_TEXT}</div>

                    <div className={styles.destopBackgroungWrapper}>
                        <img src={desktopBg} alt="destop-bg" className={styles.destopBackground} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LandingPage;
